import PostItem from "./PostItem";

export default PostItem;
